import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ImportFileOutputData } from '#/graphql/types';
import SuccessModalBase from '../base/SuccessModalBase';

interface WorkOrderSuccessModalProps {
  visible: boolean;
  onHiding: () => void;
  importResult: ImportFileOutputData | null;
}

const WorkOrderSuccessModal: React.FC<WorkOrderSuccessModalProps> = ({
  visible,
  onHiding,
  importResult,
}) => {
  const navigate = useNavigate();

  const redirectToWorkOrderList = useCallback(() => {
    onHiding();
    navigate('/work-orders/list');
  }, [onHiding, navigate]);

  return (
    <SuccessModalBase
      visible={visible}
      onHiding={onHiding}
      importResult={importResult}
      entityRecordsLabelLower="work order records"
      entityPluralLabelLower="work orders"
      onRedirect={redirectToWorkOrderList}
    />
  );
};

export default WorkOrderSuccessModal;
